<template>
    <el-table
        :data="signInTable"
        ref="B2CSignInTable"
        border
        :span-method="arraySpanMethod"
        :cell-style="rowStyle"
        class="performanceSignInTable"
        :height="height"
    >
        <el-table-column label="商品行号" prop="lineNo" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="商品编码" prop="itemCode" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="商品名称" prop="itemName" show-overflow-tooltip align="center" min-width="250px"></el-table-column>
        <el-table-column label="商品状态" prop="itemStatusName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="发货" prop="realDeliverCount" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="收货" show-overflow-tooltip align="center">
            <el-table-column label="正品签收" prop="goodSignQty" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.goodSignQty"
                        v-if="scope.$index !== signInTable.length - 1"
                        @input="computedNumber(scope.row, 'goodSignQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else> {{ scope.row.goodSignQty }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="箱损签收"
                prop="packingdmgSignQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.packingdmgSignQty"
                        v-if="scope.$index !== signInTable.length - 1"
                        @input="computedNumber(scope.row, 'packingdmgSignQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>{{ scope.row.packingdmgSignQty }}</div>
                </template>
            </el-table-column>
        </el-table-column>

        <el-table-column label="拒收" show-overflow-tooltip align="center">
            <el-table-column label="正品拒收" prop="goodRejectQty" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.goodRejectQty"
                        v-if="scope.$index !== signInTable.length - 1"
                        @input="computedNumber(scope.row, 'goodRejectQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>{{ scope.row.goodRejectQty }}</div>
                </template>
            </el-table-column>

            <el-table-column
                label="箱损拒收"
                prop="packingdmgRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.packingdmgRejectQty"
                        v-if="scope.$index !== signInTable.length - 1"
                        @input="computedNumber(scope.row, 'packingdmgRejectQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>{{ scope.row.packingdmgRejectQty }}</div>
                </template>
            </el-table-column>

            <el-table-column
                label="机损拒收"
                prop="machinedmgRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.machinedmgRejectQty"
                        v-if="scope.$index !== signInTable.length - 1"
                        @input="computedNumber(scope.row, 'machinedmgRejectQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>{{ scope.row.machinedmgRejectQty }}</div>
                </template>
            </el-table-column>
        </el-table-column>

        <el-table-column label="短少" prop="shortQty" show-overflow-tooltip align="center">
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.shortQty"
                    v-if="scope.$index !== signInTable.length - 1"
                    @input="computedNumber(scope.row, 'shortQty')"
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.shortQty }}</div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { sum, toNum, subtraction, roundDecimalPlaces, numInputLimit } from './util.js';
export default {
    name: 'B2CSignInTable',
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        tableDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        height: {
            type: Number,
            default: 320
        }
    },
    data () {
        return {
            signInTable: [],
            copyTableDataList: [],
            SignInTablePropObj: {},
            SignInTablePropArr: []
        };
    },

    methods: {
        /**
         * @description 表格居中样式
         */
        rowStyle () {
            return 'text-align:center';
        },

        /**
         * @description: 合并单元格（根据展示情况不同，合并单元格调用的方法不同）
         * @param：row 当前行
         * @param：column 当前列
         * @param：rowIndex 当前行号
         * @param：columnIndex 当前列号
         * @return {*} 合并的单元格格式
         */
        arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === this.signInTable.length - 1) {
                if (columnIndex === 0) {
                    return [1, 4];
                } else if (columnIndex === 1) {
                    return [1, 1];
                } else if (columnIndex === 2) {
                    return [1, 2];
                } else if (columnIndex === 3) {
                    return [1, 3];
                } else if (columnIndex === 4) {
                    return [1, 1];
                } else {
                    return [0, 0];
                }
            }
        },

        /**
         * @description 初始化回单签收表格数据
         */
        initTableData () {
            this.copyTableDataList = JSON.parse(JSON.stringify(this.tableDataList));
            const lastTableDataList = this.signInTable.length ? this.signInTable[this.signInTable.length - 1] : {};
            this.signInTable = lastTableDataList.hasOwnProperty('isTotalRow') && lastTableDataList.isTotalRow // 判断是否已经添加过合计
                ? this.signInTable // 已经添加过，直接使用初始化后的数据
                : this.pushLastTableList(this.copyTableDataList); // 未添加过,则将初始化后的数据 进行添加合计 操作
        },

        /**
         * @description: 计算合计 加入到table最后一行
         * @param {*} tableDataList 列表数据
         * @return {*} 加入合计后的数据
         */
        pushLastTableList (tableDataList) {
            // 动态获取table中的prop属性（判断是否存在子元素，如果存在则进行双重循环）
            this.$refs.B2CSignInTable.$children.forEach(item => {
                if (item.label && item.label !== undefined && item.$children.length === 0) {
                    this.SignInTablePropObj[item.prop] = 0;
                    this.SignInTablePropArr.push(item.prop);
                } else if (item.label && item.label !== undefined && item.$children.length !== 0) {
                    item.$children.forEach((childrenItem) => {
                        this.SignInTablePropObj[childrenItem.prop] = 0;
                        this.SignInTablePropArr.push(childrenItem.prop);
                    });
                }
            });
            // 赋值总计行数据并插入到表单数据
            tableDataList.forEach(item => {
                const realDeliverCountTotal = sum([item.realDeliverCount]);
                const takeGoodsCountTotal = sum([
                    item.goodSignQty,
                    item.packingdmgSignQty
                ]);
                const rejectGoodsCountTotal = sum([
                    item.goodRejectQty,
                    item.packingdmgRejectQty,
                    item.machinedmgRejectQty
                ]);
                const shortGoodsCountTotal = sum([item.shortQty]);
                this.SignInTablePropObj[this.SignInTablePropArr[0]] = '合 计：';
                this.SignInTablePropObj[this.SignInTablePropArr[1]] += realDeliverCountTotal; // 发货总计
                this.SignInTablePropObj[this.SignInTablePropArr[2]] += takeGoodsCountTotal; // 收货总计
                this.SignInTablePropObj[this.SignInTablePropArr[3]] += rejectGoodsCountTotal; // 拒收总计
                this.SignInTablePropObj[this.SignInTablePropArr[4]] += shortGoodsCountTotal; // 短少总计
                this.SignInTablePropObj.isTotalRow = true; // 合计行标识
            });
            Object.keys(this.SignInTablePropObj).forEach(key => {
                this.SignInTablePropObj[key] = roundDecimalPlaces(this.SignInTablePropObj[key]);
            });
            tableDataList.push(this.SignInTablePropObj);
            return tableDataList;
        },

        /**
         * @description 只能输入非负整数
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        computedNumber (row, prop) {
            row[prop] = numInputLimit(row, prop);
            const setCountParam = this.isAfterPushData();
            this.computedSumUpNumber(setCountParam);
            this.$emit('setCount', setCountParam);
        },

        /**
         * @description: 判断是否为插入总计行的数据，如果是删除总计行
         * @return {newSignInTable} 返回处理后的数据
         */
        isAfterPushData () {
            const newSignInTable = JSON.parse(JSON.stringify(this.signInTable));
            if (this.signInTable[this.signInTable.length - 1].isTotalRow) {
                newSignInTable.pop();
            }
            return newSignInTable;
        },

        /**
         * @description: 重新计算总计的数值
         * @param {*} rawData 删除总计行的表单数据
         */
        computedSumUpNumber (rawData) {
            let takeGoodsSumCount = 0;
            let shortGoodsSumCount = 0;
            let rejectGoodsSumCount = 0;
            rawData.forEach(item => {
                const takeGoodsCountTotal = sum([
                    item.goodSignQty,
                    item.packingdmgSignQty
                ]);
                const rejectGoodsCountTotal = sum([
                    item.goodRejectQty,
                    item.packingdmgRejectQty,
                    item.machinedmgRejectQty
                ]);
                const shortGoodsCountTotal = sum([item.shortQty]);
                takeGoodsSumCount += takeGoodsCountTotal;
                rejectGoodsSumCount += rejectGoodsCountTotal;
                shortGoodsSumCount += shortGoodsCountTotal;
            });
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[2]] = roundDecimalPlaces(takeGoodsSumCount);
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[3]] = roundDecimalPlaces(rejectGoodsSumCount);
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[4]] = roundDecimalPlaces(shortGoodsSumCount);
        },

        /**
         * @description 组装数据
         * @return {Array} 组装后的数据
         */
        formatReqParams () {
            const rawData = this.isAfterPushData();
            const params = rawData.map(v => {
                return {
                    abnormalCount: subtraction(Number(v.realDeliverCount), Number(v.goodSignQty)) || 0, // 总异常数量
                    id: v.id, // 商品id
                    receiptDetailId: v.id,
                    orderType: 0,
                    orderNo: this.rowData.taskNo,
                    stockoutCount: v.shortQty || 0,
                    packageDamagedCount: v.packingdmgSignQty || 0,
                    realReceive: v.goodSignQty || 0, // 正品数量
                    rejectQty: sum([v.goodRejectQty, v.packingdmgRejectQty, v.machinedmgRejectQty]) || 0,
                    custItemCode: v.custItemCode, // 客户商品编码
                    itemCode: v.itemCode, // 商品编码
                    itemName: v.itemName, // 商品名称
                    itemStatus: v.itemStatus, // 商品状态
                    itemSuiteCode: v.itemSuiteCode, // 套机编码
                    lineNo: v.lineNo, // 商品行号
                    goodSignQty: v.goodSignQty || 0, // 正品签收数量
                    packingdmgSignQty: v.packingdmgSignQty || 0, // 箱损签收数量
                    shortQty: v.shortQty || 0, // 短少数量
                    goodRejectQty: v.goodRejectQty || 0, // 正品拒收数量
                    packingdmgRejectQty: v.packingdmgRejectQty || 0, // 箱损拒收数量
                    machinedmgRejectQty: v.machinedmgRejectQty || 0, // 机损拒收数量
                    realDeliverCount: v.realDeliverCount || 0, // 发货数量
                    realReceiveCount: sum([v.goodSignQty, v.packingdmgSignQty]) || 0, // 实收数量
                    taskNo: this.rowData.taskNo, // 运输单号
                    upperLineNo: v.upperLineNo, // 上游商品行号
                    version: v.version || 0
                };
            });
            return params;
        },

        validateDataIsTrue () {
            const rawData = this.isAfterPushData();
            const realDeliverCountIsTrue = rawData.every(v => {
                const realDeliverQty = sum([
                    v.shortQty,
                    v.goodSignQty,
                    v.goodRejectQty,
                    v.packingdmgSignQty,
                    v.packingdmgRejectQty,
                    v.machinedmgRejectQty
                ]);
                return toNum(v.realDeliverCount) >= realDeliverQty;
            });
            return new Promise((resolve, reject) => {
                if (!realDeliverCountIsTrue) {
                    return reject(new Error('所有数量之和不能大于发货数！'));
                }
                resolve(this.formatReqParams());
            });
        }
    },

    mounted () {
        this.initTableData();
    },
    watch: {
        tableDataList: {
            handler (val) {
                this.initTableData();
            },
            deep: true
        }
    }

};
</script>

<style lang="less">
.performanceSignInTable {
    .customTableColumnInput {
        .el-input__inner {
            border-color: transparent;
            cursor: default;

            &:focus {
                border-color: #c3c7c7;
            }
        }
    }

    .el-input {
        vertical-align: middle;
    }

    .el-input__inner {
        text-align: center;
    }

    .notEdit {
        height: 28px;
        line-height: 28px;
        text-align: center;
    }

    .el-table__row:last-child {
        .cell {
            width: 100% !important;
        }
    }
}
</style>
